module.exports = __webpack_public_path__ + "img/introduce_content_2_ug.55c6cde5.png";